import { gql } from "@grandvisionhq/graphql";
import { deliveryEstimation } from "./delivery-estimation.js";
import { discount } from "./discount.js";
import { eligibleInsurance } from "./eligible-insurance.js";
import { insurance } from "./insurance.js";
import { legacyProduct } from "./legacy-product.js";
import { lineItemPrice } from "./line-item-price.js";
import { contactLensesTypeDetails } from "../../type-details/operations/fragments/type-details/contact-lenses.js";
import { prescriptionGlassesTypeDetails } from "../../type-details/operations/fragments/type-details/prescription-glasses.js";
import { regularTypeDetails } from "../../type-details/operations/fragments/type-details/regular.js";
import { variantFragment } from "./variant.js";
const lineItemTypeDetails = gql`
  fragment LineItemTypeDetailsFragment on LineItem {
    typeDetails {
      ... on BundlePrescriptionGlassesTypeDetails {
        __typename
        ...PrescriptionGlassesTypeDetailsFragment
      }
      ... on ContactLensesTypeDetails {
        __typename
        ...ContactLensesTypeDetailsFragment
      }
      ... on RegularTypeDetails {
        __typename
        ...RegularTypeDetailsFragment
      }
    }
    __typename
  }
  ${contactLensesTypeDetails}
  ${prescriptionGlassesTypeDetails}
  ${regularTypeDetails}
`;
const lineItemRegular = gql`
  fragment LineItemRegularFragment on LineItemRegular {
    __typename
    id
    isGift
    sku
    quantity
    lineItemType
    variant {
      ...VariantFragment
    }
    discounts {
      ...DiscountFragment
    }
    price {
      ...LineItemPriceFragment
    }
    legacyProduct {
      ...LegacyProductFragment
      __typename
    }
    eligibleInsurance {
      ...EligibleInsuranceFragment
    }
    insurance {
      ...InsuranceFragment
    }
    deliveryEstimation {
      ...DeliveryEstimationFragment
    }
  }
  ${variantFragment}
  ${legacyProduct}
  ${lineItemPrice}
  ${discount}
  ${eligibleInsurance}
  ${insurance}
  ${deliveryEstimation}
`;
const lineItemContactLenses = gql`
  fragment LineItemContactLensesFragment on LineItemContactLenses {
    __typename
    id
    isGift
    sku
    quantity
    variant {
      ...VariantFragment
    }
    discounts {
      ...DiscountFragment
    }
    price {
      ...LineItemPriceFragment
    }
    lineItemType
    legacyProduct {
      ...LegacyProductFragment
      __typename
    }
    quote {
      quoteToken
    }
    eligibleInsurance {
      ...EligibleInsuranceFragment
    }
    insurance {
      ...InsuranceFragment
    }
    deliveryEstimation {
      ...DeliveryEstimationFragment
    }
  }
  ${legacyProduct}
  ${lineItemPrice}
  ${discount}
  ${eligibleInsurance}
  ${insurance}
  ${deliveryEstimation}
  ${variantFragment}
`;
const bundleLineItem = gql`
  fragment BundleLineItemFragment on BundleLineItem {
    __typename
    sku
    type
    isMainBundleLineItem
    quantity
    discounts {
      ...DiscountFragment
    }
    price {
      ...LineItemPriceFragment
    }
    legacyProduct {
      ...LegacyProductFragment
    }
  }
  ${legacyProduct}
  ${lineItemPrice}
  ${discount}
`;
const lineItemBundle = gql`
  fragment LineItemBundleFragment on LineItemBundle {
    __typename
    id
    lineItemType
    isGift
    sku
    quantity
    discounts {
      ...DiscountFragment
    }
    price {
      ...LineItemPriceFragment
    }
    bundleLineItemsType
    bundleLineItems {
      ...BundleLineItemFragment
    }
    quote {
      quoteToken
    }
    eligibleInsurance {
      ...EligibleInsuranceFragment
    }
    insurance {
      ...InsuranceFragment
    }
    deliveryEstimation {
      ...DeliveryEstimationFragment
    }
  }
  ${lineItemPrice}
  ${discount}
  ${bundleLineItem}
  ${eligibleInsurance}
  ${insurance}
  ${deliveryEstimation}
`;
const lineItems = gql`
  fragment LineItemsFragment on Cart {
    __typename
    lineItems {
      __typename
      ...LineItemTypeDetailsFragment
      ... on LineItemRegular {
        ...LineItemRegularFragment
      }
      ... on LineItemContactLenses {
        ...LineItemContactLensesFragment
      }
      ... on LineItemBundle {
        ...LineItemBundleFragment
      }
    }
  }
  ${lineItemRegular}
  ${lineItemContactLenses}
  ${lineItemBundle}
  ${lineItemTypeDetails}
`;
export {
  bundleLineItem,
  lineItemBundle,
  lineItemContactLenses,
  lineItemRegular,
  lineItemTypeDetails,
  lineItems
};
//# sourceMappingURL=line-item.js.map
